import VRangeSlider from './VRangeSlider'

/* istanbul ignore next */
VRangeSlider.install = function install (Vue) {
  Vue.component(VRangeSlider.name, VRangeSlider)
}

export { VRangeSlider }
export default VRangeSlider
